import { AxiosResponse } from 'axios';
import { getDownloadFileCustomHeaders } from '../core/util/other';
import { useAlert, useAuth } from '../core/contexts';
import { instance as axiosInstance } from '../core/util/axiosInstance';
import { commonShowAlert } from '../lib';
import { UseQueryResult, useQuery } from 'react-query';

const fetchExportGlossary = async (
    url: string,
    token: string
): Promise<AxiosResponse<any, any>> => {
    return axiosInstance().get(url, getDownloadFileCustomHeaders(token));
};

export const useExportGlossary = (): UseQueryResult<
    AxiosResponse<any, any>,
    unknown
> => {
    const { getToken } = useAuth();
    const { showAlert, hideAlert, showErrorDetails } = useAlert();

    const url = '/metadata/glossary/export';
    return useQuery(
        'export-glossary',
        async () => fetchExportGlossary(url, getToken()),
        {
            enabled: false,
            retry: false,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            onError: (error: any) => {
                const errorMessage: string =
                    error?.data?.message ?? 'Unable to export glossary';

                commonShowAlert(
                    showAlert,
                    hideAlert,
                    'error',
                    errorMessage,
                    JSON.stringify(error?.data ?? ''),
                    showErrorDetails
                );
            },
        }
    );
};
